import { render, staticRenderFns } from "./rep_open_orders.vue?vue&type=template&id=d23ab996&scoped=true&"
import script from "./rep_open_orders.vue?vue&type=script&lang=js&"
export * from "./rep_open_orders.vue?vue&type=script&lang=js&"
import style0 from "./rep_open_orders.vue?vue&type=style&index=0&id=d23ab996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23ab996",
  null
  
)

export default component.exports